import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from "../dbconn";
import {API_ROOT} from "../api-config";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';

class contact extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            nosessionredirect: false,
            open: false,
            windowHeight: 0,
            storeName: "",
            storeAddress: "",
            storeCity: "",
            storeState: "",
            storeZip: "",
            storeNumber: "",
            storePhone: "",
        };
    };


    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        var url = "";
        if (sessionStorage.getItem('guestFlag') == 'Y') {

            this.onOpenModal();
            url = API_ROOT + '/fetchstorestats?guestFlag=Y&store_id=' + localStorage.getItem('store_id');

            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(storeData => {

                    this.onCloseModal();
                    if (storeData.status == 1) {

                        this.setState({storeName: storeData.store_data[0].store_name});
                        this.setState({storeNumber: "Store #" + storeData.store_data[0].store_number});
                        this.setState({storeAddress: storeData.store_data[0].store_address});
                        this.setState({storeCity: storeData.store_data[0].store_city + ","});
                        this.setState({storeState: storeData.store_data[0].store_state});
                        this.setState({storeZip: storeData.store_data[0].store_zip});
                        this.setState({storePhone: "Phone: " + storeData.store_data[0].store_phone});


                    }
                });


        } else {
            var dbconn = new db();

            dbconn.getAll().then(data => {

                if (!data || data.length < 1) {
                    this.setState({nosessionredirect: true});
                } else {
                    var customer_id = data[0].customer_id;
                    var customer_token = data[0].customer_token;

                    this.onOpenModal();
                    url = API_ROOT + '/fetchstorestats?guestFlag=N&customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');

                    fetch(url)
                        .then(response => {
                            return response.json();
                        })
                        .then(storeData => {

                            this.onCloseModal();
                            if (storeData.status == 1) {

                                this.setState({storeName: storeData.store_data[0].store_name});
                                this.setState({storeNumber: "Store #" + storeData.store_data[0].store_number});
                                this.setState({storeAddress: storeData.store_data[0].store_address});
                                this.setState({storeCity: storeData.store_data[0].store_city + ","});
                                this.setState({storeState: storeData.store_data[0].store_state});
                                this.setState({storeZip: storeData.store_data[0].store_zip});
                                this.setState({storePhone: "Phone: " + storeData.store_data[0].store_phone});
                            }
                        });

                }
            });
        }
    }

    componentDidMount() {


        document.title = "Contact Us - " + localStorage.getItem("store_name") + " - Tria Commerce";
        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});


    }

    render() {

        const {open} = this.state;
        const {t} = this.props;

        return (

            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/menu'}></Link>
                        <h2 className="text-center">{t('contact')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35 bkg-white full-height m-grey">
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    <h2 className="text-center font-size-20 m-0">{this.state.storeName}</h2>
                                </div>
                                <div className="header-content help_content">
                                    <p className="font-family-bold">{this.state.storeNumber} </p>

                                    <p>{this.state.storeAddress}</p>
                                    <p>{this.state.storeCity} {this.state.storeState} {this.state.storeZip}</p>
                                    <p>{this.state.storePhone}</p>
                                </div>


                            </div>


                            <div className="clearfix"></div>

                        </form>
                    </div>
                </div>


                <div className="clearfix"></div>
            </div>

        );
    }
}

export default withRouter(withTranslation()(contact));


// WEBPACK FOOTER //
// ./src/view_components/contact.js